
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getDeviceDetail } from "@/api/api-basic";
@Component
export default class EquipmentListDetail extends Vue {
  private modalShow = false;
  private loading = true;
  private modalTitle = this.$t("equipmentList.detailsTitle");
  public formItem: objAny = {};
  private tableList: object[] = [];
  private columns: object[] = [
    {
      title: this.$t("equipmentList.password"),
      key: "password",
      resizable: true,
      minWidth: 130
    },
    {
      title: this.$t("equipmentList.updateTime"),
      key: "createTime",
      resizable: true,
      minWidth: 130
    },
    {
      title: this.$t("equipmentList.status"),
      key: "statusDesc",
      resizable: true,
      minWidth: 130
    }
  ];
  async open(item: objAny) {
    this.formItem = {};
    this.tableList = [];
    this.modalShow = true;
    const res = await getDeviceDetail({ pilePkId: item.pilePkId });
    if (res.status === this.$config.apiStatus) {
      const data = res.data[0] || {};
      this.formItem = data;
      this.tableList = data.sysChargePilePwRecordVOS || [];
    }
  }
}
